<template>
  <div class="page-content service-checker-container">
    <get-estimation />
    <search-estimation-result />
  </div>
</template>

<script setup lang="ts">
import { nextTick, onMounted, defineAsyncComponent } from 'vue';
import { useRoute } from 'vue-router';

import util from '@/Utils/util';

const GetEstimation = defineAsyncComponent(() => import('./ServiceCheck/GetEstimation.vue') as any);

const SearchEstimationResult = defineAsyncComponent(() => import('./ServiceCheck/SearchEstimationResult.vue') as any);

onMounted(async () => {
  const route = useRoute();
  const hash = route.hash;

  await nextTick();
  util.moveScrollComponent(hash);
});
</script>
